import { PetitionProvider } from './../../providers/petition/petition';
import { GlobalVars } from './../../app/app.environment';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-mailbox',
  templateUrl: 'mailbox.html',
})
export class MailboxPage {

  public areas: Array<any> = [];
  public areasRef;
  public missatges: Array<any> = [];
  public peticionsVacancesRef;

  public loading;

  petitions;
  
  constructor(
    public globalVars: GlobalVars,
    public toast: ToastController,
    public loadingCtrl: LoadingController, 
    public navCtrl: NavController, 
    public navParams: NavParams,
    public petitionProvider: PetitionProvider,
  ) {      
    this.petitions = petitionProvider.getUserMailbox()
  }

  accept(petition) {
    this.petitionProvider.markRead(petition)
  }

  info(petition) {
    this.navCtrl.push('PetitionInfoPage', { mode:'mailbox', petition: petition});
  }
}



// WEBPACK FOOTER //
// ./src/pages/mailbox/mailbox.ts